module.exports = __webpack_public_path__ + "static/img/topbg.0aa83136.png";